import $ from 'jquery';

export default function modalSection() {
	const $html = $('html');
	const $modal = $('#modal');
	const $iframe = $modal.find('iframe');
	const toggler = $modal.data('toggler');

	const url = $modal.attr('data-url');
	
	$('a[href^="'+url+'/"]').attr('target', 'modal-frame');

	function resetIframe() {
		$iframe.attr('src', '');
		$iframe.attr('src', 'about:blank');
	}

	if (toggler) {

		$iframe.on('load', function() {
			try {
				const href = $iframe[0].contentWindow.location.href;
				const isBlank = href === 'about:blank';
				toggler.toggle(!isBlank);

			} catch(e) {
				toggler.close();
			}

			// console.log('asdf');
		});

		$modal.on('click', function(e) {
			if (e.target === this) {
				toggler.close();
				resetIframe();
			}
		});

		toggler.on('toggle', function() {
			// console.log(toggler.isOpen);
			$html.toggleClass('is-modal-open', toggler.isOpen);

			if(toggler.isOpen == false) {
				resetIframe();
			}
		});
	}

      // pop a modal
      const popupModal = el => {

            // don't pop if cookie is set
            const cookieName = `spicyPopupModal${el.id}`,
                  popped = document.cookie
                        .split('; ').find(row => row.startsWith(`${cookieName}=`));
            if (!popped || el.dataset.devmode) {

                  // pop
                  const frame = document.getElementById("modal").querySelector('iframe');
                  if (frame) frame.src = el.dataset.url;

                  // set cookie
                  let expiry = new Date();
                  expiry.setTime(expiry.getTime() + (el.dataset.expiry * 60 * 60 * 1000));
                  document.cookie = `${cookieName}=true; expires=${expiry.toUTCString()};`;
            }
      };

      // go over each popup modal box in the page and pop it with timers
      [...document.querySelectorAll('.popup-modal')].forEach(el => {

            // delays
            if (el) setTimeout(() => { popupModal(el); }, (el.dataset.delay * 1000));
      });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/modal.js